(() => {
  if (customElements.get('detropolis-street-value')) return;
  customElements.define('detropolis-street-value', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      try { this.data = JSON.parse(this.querySelector('[data-value-data]').textContent); } catch (_) { return; }
      this.baseLabel = this.querySelector('[data-value-mode]').textContent;
      const options = { signal:this.events.signal };
      this.addEventListener('click', event => {
        if (!event.target.closest('[data-value-edit]')) return;
        const map = this.findMap();
        const index = map?.vaultIndex?.();
        if (Number.isInteger(index) && index >= 0 && map.ready) {
          if (this.dataset.designMode === 'true') {
            this.querySelector('[data-value-help]').textContent = 'Comprueba la selección y el carrito desde la vista previa de la tienda.';
            return;
          }
          map.openPack(index);
        }
      }, options);
      document.addEventListener('detropolis:vault-updated', event => {
        if (String(event.detail?.productId) === this.dataset.productId) this.sync();
      }, options);
      ['detropolis:route-ready','sounplace:cart-updated','shopify:section:load'].forEach(name => document.addEventListener(name, () => this.sync(), options));
      customElements.whenDefined('detropolis-street-map').then(() => { if (this.events && this.isConnected) this.sync(); });
      this.findMap()?.querySelector('.dt-street-map__city')?.addEventListener('load', () => this.sync(), options);
      this.sync();
    }
    findMap() {
      return [...document.querySelectorAll('detropolis-street-map')].find(map => String(map.dataset.pageKey) === this.dataset.productId);
    }
    format(variant) {
      const initial = this.data.variants.find(item => String(item.id) === String(variant.id));
      if (initial?.price === variant.price) return initial.formatted;
      try { return new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency',currency:this.data.currency}).format(variant.price / 100); }
      catch (_) { return String(variant.price / 100); }
    }
    sync() {
      if (!this.data) return;
      const map = this.findMap();
      const withVault = map?.withVault || this.data.variants.find(variant => variant.options?.includes('Con Baúl'));
      const withoutVault = map?.withoutVault || this.data.variants.find(variant => variant.options?.includes('Sin Baúl'));
      const savedSelection = map?.vaultSelection || {mode:'unset',ids:[]};
      const selection = !withVault?.available && withoutVault?.available
        ? {mode:'without',ids:[]}
        : savedSelection;
      const selected = selection.mode === 'with' ? (map?.catalog || []).filter(item => selection.ids.includes(item.id)) : [];
      const configured = !!withVault && !!withoutVault;
      const anyAvailable = configured && (withVault.available || withoutVault.available);
      const pending = selection.mode === 'unset' && !!withVault?.available;
      const invalid = selection.mode === 'with' && (!withVault?.available || !selected.length || selected.length > 4 || selected.length !== selection.ids.length);
      let chosen = null;
      if (!pending && !invalid) chosen = selection.mode === 'with' ? withVault : withoutVault;
      const available = configured ? [withVault,withoutVault].filter(variant => variant.available) : [];
      const displayVariant = chosen?.available ? chosen : available[0];
      const modeNode = this.querySelector('[data-value-mode]');
      const priceNode = this.querySelector('[data-value-price]');
      const selectionNode = this.querySelector('[data-value-selection]');
      const edit = this.querySelector('[data-value-edit]');
      const buy = this.querySelector('[data-detropolis-purchase]');
      const gifts = this.querySelector('[data-value-gifts]');
      priceNode.textContent = displayVariant ? this.format(displayVariant) : this.dataset.soldOutLabel;
      modeNode.textContent = displayVariant?.available ? `${this.baseLabel} · ${displayVariant === withVault ? this.dataset.withLabel : this.dataset.withoutLabel}` : this.baseLabel;
      if (!anyAvailable) selectionNode.textContent = this.dataset.soldOutLabel;
      else if (invalid) selectionNode.textContent = 'Revisa tu selección del Baúl antes de continuar.';
      else if (pending) selectionNode.textContent = this.dataset.pendingLabel;
      else selectionNode.textContent = chosen === withVault ? `${this.dataset.withLabel} · ${selected.length} ${selected.length === 1 ? 'bundle elegido' : 'bundles elegidos'}` : this.dataset.withoutLabel;
      gifts.replaceChildren();
      if (chosen === withVault && !invalid) selected.forEach(item => {
        const li = document.createElement('li'); li.textContent = item.title; gifts.append(li);
      });
      gifts.hidden = !gifts.children.length;
      edit.textContent = selection.mode === 'unset' ? this.dataset.chooseLabel : this.dataset.editLabel;
      edit.disabled = !map?.ready || !configured || !withVault.available;
      if (buy) buy.disabled = !map?.ready || !anyAvailable;
      this.dataset.selectionMode = invalid ? 'invalid' : pending ? 'pending' : chosen === withVault ? 'with' : 'without';
      this.querySelector('[data-value-help]').textContent = !configured || !map ? 'La compra no está disponible en este momento.' : '';
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
})();
